import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Collections from "./pages/Collections";
import Capabilities from "./pages/Capabilities";
import Contact from "./pages/Contact";
import ThankYou from "./pages/ThankYou";

function App() {
    return (
        <BrowserRouter>
            <Layout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/collections" element={<Collections />} />
                    <Route path="/capabilities" element={<Capabilities />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/thank-you" element={<ThankYou />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </Layout>
        </BrowserRouter>
    );
}

export default App;
